import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./disclaimerHowItWorksModal.css";

const DiscardChangesModal = ({ show, onHide, onConfirm }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="disclaimer-how-it-works-modal-wrapper"
    >
      <Modal.Body className="pt-0">
        <Modal.Header className="modal-title-with-border" closeButton>
          <Modal.Title>Discard Changes and Leave?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 pb-2">
          <p className="mb-2">You have unsaved changes.</p>
          <p className="mb-0">Do you want to leave without saving?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            Leave
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default DiscardChangesModal;
